import React from 'react'

import TextButton from '../textButton/TextButton'

const PrimaryTextButton = ({ ...props }) => {
  // @ts-expect-error TS(2741): Property 'onClick' is missing in type '{ isPrimary... Remove this comment to see the full error message
  return <TextButton isPrimary {...props} />
}

export default PrimaryTextButton
